export const convertNameToSnakeCase = (text: string): string =>
  text.toLowerCase().replaceAll(' ', '_');
